import { render } from "./Program02.vue?vue&type=template&id=beaeed1c"
import script from "./Program02.vue?vue&type=script&lang=js"
export * from "./Program02.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__